
const allSuits = [
    "Diamond", "Clubs", "Spades","Hearts"
]

const createCard = (aRank,aSuit) => {
    return {
        rank: aRank,
        suit: aSuit
    }
}



export const shuffleDeck = (deck) => {
    for(let i = deck.length-1; i >= 0; i--){

        let randIndex = Math.floor(Math.random()*i);

        let temp = deck[i];
        deck[i] = deck[randIndex];
        deck[randIndex] = temp;

    }
}

export const createDeck = () => {

    let deck = []

    for(let rank = 1; rank <= 13; rank++){
        for(let p = 0; p < allSuits.length; p++){
            let suit = allSuits[p];
            deck.push(createCard(rank,suit));
        }
    }

    shuffleDeck(deck);

    return deck;
}

export const createDeck2 = () => {
    let deck = []
    allSuits.forEach((suit) => {
        for(let rank = 1; rank <= 13; rank++){
            deck.push(createCard(rank,suit))
        }
    })

    shuffleDeck(deck);

    return deck;
}



